const _temp0 = require("../../vodalys2023/branding/vlang/fr.js");

const _temp1 = require("../../vodalys2023/gladia/vlang/fr.js");

const _temp2 = require("../../vodalys2023/home24/vlang/en.js");
const _temp3 = require("../../vodalys2023/home24/vlang/fr.js");
const _temp4 = require("../../vodalys2023/home24/storage_clean/vlang/fr.js");


const _temp5 = require("../../vodalys2023/mood/vlang/fr.js");

const _temp6 = require("../../vodalys2023/plan/vlang/fr.js");
const _temp7 = require("../../vodalys2023/plan/vwallet/vlang/fr.js");


const _temp8 = require("../../vodalys2023/playerholder3/vlang/en.js");
const _temp9 = require("../../vodalys2023/playerholder3/vlang/fr.js");

const _temp10 = require("../../vodalys2023/question24/vlang/fr.js");

const _temp11 = require("../../vodalys2023/stepin/vlang/fr.js");

const _temp12 = require("../../vodalys2023/stripe/vlang/fr.js");
const _temp13 = require("../../vodalys2023/stripe/orders/vlang/fr.js");


const _temp14 = require("../../vodalys2023/studio20_layout23/vlang/fr.js");

const _temp15 = require("../../vodalys2023/subtitle/vlang/en.js");
const _temp16 = require("../../vodalys2023/subtitle/vlang/fr.js");

const _temp17 = require("../../vodalys2023/talkto/vlang/fr.js");

const _temp18 = require("../../vodalys2023/transcript/vlang/en.js");
const _temp19 = require("../../vodalys2023/transcript/vlang/fr.js");

const _temp20 = require("../../vodalys2023/translate25/vlang/en.js");
const _temp21 = require("../../vodalys2023/translate25/vlang/fr.js");

const _temp22 = require("../../vodalys2023/troubleshooting/vlang/en.js");
const _temp23 = require("../../vodalys2023/troubleshooting/vlang/fr.js");

const _temp24 = require("../../vodalys2023/vodalys_bridge/vlang/fr.js");


const _temp25 = require("../../vodalys/vconsole17_whistleblower/vlang/fr.js");

const _temp26 = require("../../vodalys/vcost_slider/vlang/fr.js");

const _temp27 = require("../../vodalys/vcreator18/vlang/fr.js");

const _temp28 = require("../../vodalys/vfigma/vlang/fr.js");

const _temp29 = require("../../vodalys/vform17/vlang/fr.js");

const _temp30 = require("../../vodalys/vform17_timecode_picker/vlang/fr.js");

const _temp31 = require("../../vodalys/vform17_graph/vlang/fr.js");

const _temp32 = require("../../vodalys/vodalys_form/vlang/fr.js");

const _temp33 = require("../../vodalys/vproject17/vlang/fr.js");

const _temp34 = require("../../vodalys/vprojector/vlang/fr.js");

const _temp35 = require("../../vodalys/vrun_form/vlang/fr.js");

const _temp36 = require("../../vodalys/vrun_sas/vlang/en.js");
const _temp37 = require("../../vodalys/vrun_sas/vlang/fr.js");

const _temp38 = require("../../vodalys/vstudio20/vlang/fr.js");

const _temp39 = require("../../vodalys/vstudio20_presets/vlang/fr.js");

const _temp40 = require("../../vodalys/vuser/vlang/fr.js");
const _temp41 = require("../../vodalys/vuser/account17/vlang/fr.js");


const _temp42 = require("../../vodalys/vvod/vlang/en.js");
const _temp43 = require("../../vodalys/vvod/vlang/fr.js");

const _temp44 = require("../../vodalys/vwallet/vlang/fr.js");

const _temp45 = require("../../vodalys/whitelist/vlang/en.js");
const _temp46 = require("../../vodalys/whitelist/vlang/fr.js");

const _temp47 = require("../../vodalys/zapper/vlang/fr.js");

const _temp48 = require("../../vodalys/vconsole17/modal/vlang/fr.js");


const _temp49 = require("../../vodalys/vconsole17_vue/open21/vlang/fr.js");



module.exports = {
  "vodalys2023":   {
    "branding":     {
      "fr": _temp0
    },
    "gladia":     {
      "fr": _temp1
    },
    "home24":     {
      "en": _temp2,
      "fr": _temp3,
      "storage_clean":       {
        "fr": _temp4
      }
    },
    "mood":     {
      "fr": _temp5
    },
    "plan":     {
      "fr": _temp6,
      "vwallet":       {
        "fr": _temp7
      }
    },
    "playerholder3":     {
      "en": _temp8,
      "fr": _temp9
    },
    "question24":     {
      "fr": _temp10
    },
    "stepin":     {
      "fr": _temp11
    },
    "stripe":     {
      "fr": _temp12,
      "orders":       {
        "fr": _temp13
      }
    },
    "studio20_layout23":     {
      "fr": _temp14
    },
    "subtitle":     {
      "en": _temp15,
      "fr": _temp16
    },
    "talkto":     {
      "fr": _temp17
    },
    "transcript":     {
      "en": _temp18,
      "fr": _temp19
    },
    "translate25":     {
      "en": _temp20,
      "fr": _temp21
    },
    "troubleshooting":     {
      "en": _temp22,
      "fr": _temp23
    },
    "vodalys_bridge":     {
      "fr": _temp24
    }
  },
  "vodalys":   {
    "vconsole17_whistleblower":     {
      "fr": _temp25
    },
    "vcost_slider":     {
      "fr": _temp26
    },
    "vcreator18":     {
      "fr": _temp27
    },
    "vfigma":     {
      "fr": _temp28
    },
    "vform17":     {
      "fr": _temp29
    },
    "vform17_timecode_picker":     {
      "fr": _temp30
    },
    "vform17_graph":     {
      "fr": _temp31
    },
    "vodalys_form":     {
      "fr": _temp32
    },
    "vproject17":     {
      "fr": _temp33
    },
    "vprojector":     {
      "fr": _temp34
    },
    "vrun_form":     {
      "fr": _temp35
    },
    "vrun_sas":     {
      "en": _temp36,
      "fr": _temp37
    },
    "vstudio20":     {
      "fr": _temp38
    },
    "vstudio20_presets":     {
      "fr": _temp39
    },
    "vuser":     {
      "fr": _temp40,
      "account17":       {
        "fr": _temp41
      }
    },
    "vvod":     {
      "en": _temp42,
      "fr": _temp43
    },
    "vwallet":     {
      "fr": _temp44
    },
    "whitelist":     {
      "en": _temp45,
      "fr": _temp46
    },
    "zapper":     {
      "fr": _temp47
    },
    "vconsole17":     {
      "modal":       {
        "fr": _temp48
      }
    },
    "vconsole17_vue":     {
      "open21":       {
        "fr": _temp49
      }
    }
  }
}